import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { actions } from "../model";
import { getSubsessions } from "../selectors";
import Subsession from "./Subsession";
import { Div, BigOutlineButton, BigFilledButton } from "components/Base";
import { Panel, PanelTitle } from "EventLight/Common/FieldLayout";
import EmptyState from "EventLight/Common/EmptyState";

import CSSModules from "react-css-modules";
import css from "./styles.scss";

import CanUserDo from "components/Global/Security/CanUserDo";
import * as STANDARD_MODULE_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-modules";

const decorate = R.compose(
  connect(
    state => ({
      subsessions: getSubsessions(state)
    }),
    {
      createSubsession: actions.createSubsession,
      handleConvertSessionstoSubsessions:
        actions.handleConvertSessionstoSubsessions
    }
  ),
  CSSModules(css)
);

const Layout = ({
  subsessions,
  createSubsession,
  handleConvertSessionstoSubsessions,
  handlers = {}
}) => {
  return (
    <Div bg="neutral0">
      <Div display="row.flex-end.center" mb={3}>
        <CanUserDo action={`${STANDARD_MODULE_IDS.sessions.id}_update`}>
          <BigOutlineButton
            className={css.actionButton1}
            mr={3}
            display="row.space-between.center"
            color="neutral7"
            onClick={() => handleConvertSessionstoSubsessions()}
          >
            Convert sessions to subsessions
          </BigOutlineButton>
        </CanUserDo>

        <CanUserDo action={`${STANDARD_MODULE_IDS.sessions.id}_create`}>
          <BigFilledButton
            className={css.actionButton2}
            bg="neutral2"
            onClick={() => createSubsession()}
          >
            Create subsession
          </BigFilledButton>
        </CanUserDo>
      </Div>

      <Panel>
        <PanelTitle>
          <Div
            display="row.flex-start.center"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            <div>Linked Subsessions</div>
          </Div>
        </PanelTitle>

        {!R.isEmpty(subsessions) && !R.isNil(subsessions) ? (
          <Div>
            {subsessions.map(subsession => (
              <Subsession
                instanceID={subsession.id}
                subsession={subsession}
                handlers={handlers}
              />
            ))}
          </Div>
        ) : (
          <EmptyState
            icon="event"
            title="No subsessions have been added yet"
            style={{
              margin: "0px 30px 30px 30px",
              flex: 1,
              border: 0
            }}
          />
        )}
      </Panel>
    </Div>
  );
};

export default decorate(Layout);
